module.exports = __webpack_public_path__ + "img/StorageBySQM-min.ee8a2d38.png";